/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { InfiniteMatDataSource } from '@gh/common-external-shared';
import { ID } from '@gh/common-shared-data';
import { openInNewWindow } from '@gh/core-util';
import { SharedDocsModel, SupplierSharedDocsListBusinessService } from '../../resources';

@Component({
  selector: 'gh-shared-docs',
  templateUrl: 'supplier-shared-docs-list.component.html',
})
export class SupplierSharedDocsListComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  dataSource: InfiniteMatDataSource<SharedDocsModel>;
  displayedColumns: string[] = ['fileName', 'fileId'];

  constructor(
    private route: ActivatedRoute,
    private businessService: SupplierSharedDocsListBusinessService,
  ) {
  }

  ngOnInit(): void {
    this.subscribeToNavigation();
  }

  getDocId(index: number, doc: SharedDocsModel): ID {
    return doc.fileId;
  }

  view(doc: SharedDocsModel): void {
    openInNewWindow(doc.fileUrl);
  }

  private loadDocs(): void {
    this.dataSource = InfiniteMatDataSource.wrap(this.businessService.getAll());
    this.dataSource.sort = this.sort;
  }

  private subscribeToNavigation(): void {
    this.route
      .params
      .subscribe(() => this.loadDocs());
  }
}
